import { DataExtractionValueBase } from './DataExtractionValueBase';

export const __typename = 'DataExtractionValueTextDto';
export class DataExtractionValueText extends DataExtractionValueBase {
  constructor(data = {}) {
    super({ ...data, __typename });
    this.value = data.value ?? '';
  }
}
